import {TargetBlank} from '@wandb/weave/common/util/links';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React, {useState} from 'react';

import {Banner, BannerTextWrapper} from '../../Banner';
import {ExternalLink} from '../utilTypes';
import * as S from './ExternalMonitoring.styles';
import {LinksDrawer} from './LinksDrawer';

type ExternalLinksProps = {
  queueID: string;
  links: ExternalLink[];
};

export const ExternalMonitoring = ({queueID, links}: ExternalLinksProps) => {
  const [linksDrawerOpen, setLinksDrawerOpen] = useState(false);
  const [linkData, setLinkData] = useState(links);
  const closeDrawer = () => {
    setLinksDrawerOpen(false);
  };

  const linkButtons = (linkItems: ExternalLink[]) => {
    return linkItems.map((link: ExternalLink, index: number) => {
      return (
        // eslint-disable-next-line react/jsx-key
        <TargetBlank href={link.url}>
          <Button size="large" variant="secondary" style={{margin: '8px'}}>
            {link.label}
          </Button>
        </TargetBlank>
      );
    });
  };

  return (
    <S.ExternalLinks>
      <S.Header>
        <S.SectionTitle>External Monitoring</S.SectionTitle>
        <S.Spacer />
        <Button
          size="large"
          variant="secondary"
          icon="pencil-edit"
          onClick={() => setLinksDrawerOpen(open => !open)}
          style={{margin: 10}}>
          Manage links
        </Button>
      </S.Header>
      <S.LinkRow>{linkData.length > 0 && linkButtons(linkData)}</S.LinkRow>
      {linkData.length === 0 && (
        <div style={{width: '100%'}}>
          <Banner
            variant="info"
            className="mt-24"
            style={{
              margin: 10,
            }}>
            <BannerTextWrapper>
              Add your own links to external infrastructure monitoring tools for
              this queue.
            </BannerTextWrapper>
          </Banner>
        </div>
      )}
      <LinksDrawer
        open={linksDrawerOpen}
        links={linkData || []}
        setLinks={setLinkData}
        queueID={queueID}
        closeDrawer={closeDrawer}
      />
    </S.ExternalLinks>
  );
};
